import { ActionButtonConfig, initActionButtonDefaultConfigs } from 'src/app/shared/models/action-button.model';
import {
    ConfirmationDialogSettings,
    InitCancelConfirmationDialogSettings,
    InitCloseConfirmationDialogSettings
} from 'src/app/shared/models/confirmation-dialog-settings.model';

export interface SidePanelConfig {
    title?: string;
    alertMessage?: string;
    alertType?: 'warning' | 'alert' | 'important' | 'confirmation' | 'info';
    alertMessageOverrideClass?: string;
    actionButtons: ActionButtonConfig[];
    footerMessages?: FooterMessage[];
    showFooter: boolean;
    isCancelDialogEnabled?: boolean;
    cancelConfirmationDialogConfig?: ConfirmationDialogSettings;
    cancelConfirmationDialogCloseValue?: boolean | undefined;
    isSaveButtonActive: false;
    isOpenByDefault: boolean;
    overrideCancelEnabled: boolean;
    extendHeight?: boolean;
    backIconEnabled?: boolean;
    disableCloseIcon?: boolean;
    width?: string;
    minWidth?: string;
    closeOnOverlayClick?: boolean;
    disableDefaultPadding?: boolean;
}

export interface FooterMessage {
    icon?: string;
    color?: string;
    message: string;
}

export enum SidePanelConfigDefaultIdentifiers {
    Save = 1,
    Cancel = 2,
    ConfirmationYes = 3,
    ConfirmationContinueEdit = 4,
    Docusign = 5,
    Delete = 6
}

export const initSidePanelConfig = (sidePanelConfig?: Partial<SidePanelConfig>): SidePanelConfig => {
    const defaults: SidePanelConfig = {
        title: 'Title',
        alertMessage: '',
        alertMessageOverrideClass: '',
        actionButtons: initActionButtonDefaultConfigs(),
        footerMessages: [],
        showFooter: true,
        isCancelDialogEnabled: false,
        cancelConfirmationDialogConfig: InitCancelConfirmationDialogSettings(),
        cancelConfirmationDialogCloseValue: true,
        isSaveButtonActive: false,
        isOpenByDefault: false,
        overrideCancelEnabled: false,
        extendHeight: false,
        backIconEnabled: false,
        disableCloseIcon: false,
        minWidth: '500px',
        width: '500px',
        closeOnOverlayClick: false,
        disableDefaultPadding: false
    };

    return {
        ...defaults,
        ...sidePanelConfig
    };
};

export const initSidePanelWithCloseConfirmationConfig = (
    sidePanelConfig?: Partial<SidePanelConfig>
): SidePanelConfig => {
    const defaults: SidePanelConfig = {
        title: 'Title',
        alertMessage: '',
        alertMessageOverrideClass: '',
        actionButtons: initActionButtonDefaultConfigs(),
        footerMessages: [],
        showFooter: true,
        isCancelDialogEnabled: false,
        cancelConfirmationDialogConfig: InitCloseConfirmationDialogSettings(),
        cancelConfirmationDialogCloseValue: undefined,
        isSaveButtonActive: false,
        isOpenByDefault: false,
        overrideCancelEnabled: false,
        extendHeight: false,
        backIconEnabled: false,
        disableCloseIcon: false
    };

    return {
        ...defaults,
        ...sidePanelConfig
    };
};
